import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import {
  MDBBtn,
  MDBContainer,
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBModalHeader,
  MDBModalBody,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import moment from 'moment'

class ViewSignatures extends Component {
  constructor(props) {
    super(props)
    this.state = {
      breakWidth: 1300,
      windowWidth: 0,
      signatureList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      termName: '',
      viewdata: '',
      userterm: [],
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Agent Name',
            field: 'name',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Signed Date',
            field: 'signed',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Select',
            field: 'select',
            sort: 'disabled',
            width: 150,
          },
        ],
        rows: [],
      },
    }
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    this.setState({ urlParams: params })

    if (params && params.id) {
      // this.fetchSignatureData(params.id);
      this.fetchTermsData(params.id)
    }
  }

  //convert date from sec to current date
  toDateTime = secs => {
    let t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeleteSignature = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { signatureList } = this.state
    if (signatureList && signatureList.length) {
      let rows = signatureList.map(row => {
        const { userterm_user, updated_at, id } = row
        const submittedDate = (
          <span data-searchvalue={updated_at ? moment(updated_at).format('YYYY/MM/DD') : ''}>
            {updated_at ? moment(updated_at).format('MM/DD/YYYY') : 'N/A'}
          </span>
        )
        const self = this

        function handleCheckboxSelect(event) {
          const idVal = String(event.target.value)
          const userterm = [...(self.state.userterm || [])]
          const idx = userterm.indexOf(idVal)
          if (idx > -1) userterm.splice(idx, 1)
          else userterm.push(idVal)
          self.setState({ userterm }, () => self.setRows())
        }

        const idStr = String(id)
        const isChecked = self.state.userterm && self.state.userterm.indexOf(idStr) > -1
        const checkBox = (
          <div className='d-flex align-items-center justify-content-center'>
            <div className='form-check form-check-inline-visible'>
              <input
                type='checkbox'
                className='form-check-input'
                id={`sig-select-${id}`}
                value={idStr}
                checked={!!isChecked}
                onChange={handleCheckboxSelect}
              />
              <label className='form-check-label' htmlFor={`sig-select-${id}`}>
                Select
              </label>
            </div>
          </div>
        )

        return {
          name: userterm_user,
          signed: submittedDate,
          select: checkBox,
        }
      })

      this.setState({
        data: { ...this.state.data, rows: rows || [] },
      })
    }
  }

  //Fetch data
  fetchSignatureData = async id => {
    try {
      const result = await AdminApi.getSignatures(id)
      this.setState({ signatureList: result?.data?.data || [] }, () => this.setRows())
    } catch (error) {
      toast.error('Something went wrong while loading signatures.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  fetchTermsData = async id => {
    try {
      this.setState({ loading: true })

      const result = await AdminApi.getTermsById(id)
      const content = result?.data?.data

      if (content) {
        this.setState({ termName: content.term_name || '' })
        await this.fetchSignatureData(id) // fetch signature data only after terms are loaded
      }

      this.setState({ loading: false })
    } catch (error) {
      this.setState({ loading: false })
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  //Delete data
  _DeleteSignatures = async id => {
    const { userterm } = this.state
    this.setState({ deleting: true })
    const data = { userterm_id: userterm }

    /*let form_data = new FormData();

        for ( let key in data ) {
            form_data.append(key, data[key]);
        }*/

    AdminApi.deleteSignature(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Signature successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchSignatureData(this.state.urlParams.id)
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { loading, confirmModal, data } = this.state

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <MDBBreadcrumb>
                <MDBBreadcrumbItem>
                  <a href='/admin-terms'>List</a>
                </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>View Signatures</MDBBreadcrumbItem>
              </MDBBreadcrumb>
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <>
                  <h2>{this.state.termName}</h2>
                  <MDBBtn type='button' color='danger' className='mt-2 mb-3' onClick={this.confirm_DeleteSignature}>
                    Delete
                  </MDBBtn>
                  {data && (
                    <>
                      <MDB4Datatable
                        data={data}
                        sortRows={['signed']}
                        striped
                        bordered
                        small
                        className='text-capitalize'
                      />
                    </>
                  )}
                </>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Signatures</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      {this.state.userterm && this.state.userterm.length ? (
                        <>
                          <div className='h5'>Are you sure you want to delete selected signature(s)?</div>
                          <div className='d-flex flex-wrap gap-2 mt-2'>
                            <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                              Close
                            </MDBBtn>
                            <MDBBtn
                              type='button'
                              color='danger'
                              size={'sm'}
                              onClick={() => {
                                this._DeleteSignatures(this.state.viewdata.id)
                              }}
                            >
                              {this.state.deleting ? 'Deleting...' : 'Delete'}
                            </MDBBtn>
                          </div>
                        </>
                      ) : (
                        <div className='h5'>Please select signatures to delete.</div>
                      )}
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default ViewSignatures
